import script from "./Inspections.vue?vue&type=script&setup=true&lang=js"
export * from "./Inspections.vue?vue&type=script&setup=true&lang=js"

import "./Inspections.vue?vue&type=style&index=0&id=d6fd4462&lang=css"

const __exports__ = script;

export default __exports__